export interface Product {
  id: string;
  name: string;
  tagline: string;
  description: string;
  platform: string;
  category: string;
  status: 'Published' | 'Coming Soon';
  iconUrl: string;
  iosUrl?: string | null;
  androidUrl?: string | null;
  macUrl?: string | null;
  detailPath?: string | null;
  supportPath?: string | null;
  features: string[];
}

/** Live apps from App Store + Google Play developer listings */
export const productCatalog: Product[] = [
  {
    id: 'budget-atlas',
    name: 'Budget Atlas',
    tagline: 'Manual money tracker. No bank.',
    description:
      'Personal money tracker for wallets, spending, budgets, bills, and goals. You enter transactions yourself — no bank login, no account aggregation, and no payment processing.',
    platform: 'iOS & Android',
    category: 'Finance',
    status: 'Published',
    iconUrl:
      'https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/bf/76/95/bf7695f9-73b5-2c64-e23f-2400547f4cde/AppIcon-0-0-1x_U007epad-0-1-85-220.png/512x512bb.jpg',
    iosUrl: 'https://apps.apple.com/us/app/budget-atlas/id6801154973',
    androidUrl: 'https://play.google.com/store/apps/details?id=com.pradappandiyan.budgetplanner',
    features: ['Wallets & currencies', 'Budgets', 'Bills & goals', 'No bank login']
  },
  {
    id: 'mechanic-toolbox',
    name: 'Mechanic Toolbox',
    tagline: 'Offline auto shop calculators',
    description:
      'Offline toolkit of automotive calculators for mechanics, DIY owners, and workshop use. Tyre, torque, gearing, fuel, EV, battery, engine, 4x4, suspension, brake, performance, and towing — no account and no internet required.',
    platform: 'iOS',
    category: 'Utilities',
    status: 'Published',
    iconUrl:
      'https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/37/64/fb/3764fbc2-fc71-63c6-b50c-343d73566d71/AppIcon-0-0-1x_U007emarketing-0-11-0-85-220.png/512x512bb.jpg',
    iosUrl: 'https://apps.apple.com/us/app/mechanic-toolbox/id6805532200',
    features: ['Offline calculators', 'Vehicle profiles', 'Workshop tools', 'No account']
  },
  {
    id: 'replio-gymfit',
    name: 'Replio GymFit',
    tagline: 'Log workouts by muscle',
    description:
      'Stay consistent without complicated logging. Build your weekly plan by muscle groups, then log what you trained in one tap — structure and accountability without entering every set and rep.',
    platform: 'iOS & Android',
    category: 'Health & Fitness',
    status: 'Published',
    iconUrl:
      'https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/fa/4b/c8/fa4bc857-a2c0-ff35-eb17-c12317a3f32a/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/512x512bb.jpg',
    iosUrl: 'https://apps.apple.com/us/app/replio-gymfit/id6802663164',
    androidUrl: 'https://play.google.com/store/apps/details?id=com.pradappandiyan.gymworkout',
    supportPath: '/replio-gymfit-support',
    features: ['Muscle-based plans', 'One-tap logging', 'Weekly structure', 'Simple tracking']
  },
  {
    id: 'plan-mesh',
    name: 'Plan Mesh',
    tagline: 'Shop and travel together',
    description:
      'Collaborative shopping lists and shared carts. Invite people with a QR code or link, assign items, and track what’s pending, in progress, or purchased so everyone stays in sync.',
    platform: 'iOS & Android',
    category: 'Productivity',
    status: 'Published',
    iconUrl:
      'https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/2f/3e/58/2f3e5855-5a68-351b-1a51-f111f42653ee/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/512x512bb.jpg',
    iosUrl: 'https://apps.apple.com/us/app/plan-mesh/id6796434239',
    androidUrl: 'https://play.google.com/store/apps/details?id=com.pradappandiyan.shoptogether',
    features: ['Shared carts', 'QR invites', 'Item status', 'Group shopping']
  },
  {
    id: 'auto-maintenance',
    name: 'Auto Maintenance',
    tagline: 'Vehicle care companion',
    description:
      'Track service history, fuel costs, expenses, documents, and reminders across cars, motorcycles, and trucks. Keep every vehicle organized with analytics and cloud backup.',
    platform: 'iOS & Android',
    category: 'Utilities',
    status: 'Published',
    iconUrl:
      'https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/d1/e3/71/d1e37176-55aa-6b8f-7456-b62bae17975c/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/512x512bb.jpg',
    iosUrl: 'https://apps.apple.com/us/app/auto-maintenance-app/id6751143390',
    androidUrl: 'https://play.google.com/store/apps/details?id=com.maintence.car.carmaintence',
    detailPath: '/app/car-maintenance',
    features: ['Service history', 'Fuel & expenses', 'Reminders', 'Multi-vehicle']
  },
  {
    id: 'date-time-calculator',
    name: 'Date and Time Calculator',
    tagline: 'Smart date & time tools',
    description:
      '50+ professional date and time tools for differences, business days, countdowns, age, and more — built for professionals, students, and everyday planning.',
    platform: 'iOS & Android',
    category: 'Utilities',
    status: 'Published',
    iconUrl:
      'https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/38/95/40/389540bd-47b4-abdc-22cb-d91379ce45e0/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/512x512bb.jpg',
    iosUrl: 'https://apps.apple.com/us/app/date-and-time-calculator/id6751056998',
    androidUrl:
      'https://play.google.com/store/apps/details?id=com.maestro.date_and_time_calculator',
    features: ['50+ tools', 'Business days', 'Countdowns', 'Offline']
  },
  {
    id: 'kinora',
    name: 'Kinora - Stay Close',
    tagline: 'Stay close to people who matter',
    description:
      'Reminders, notes, and moments that help you stay connected with the people who matter most.',
    platform: 'Android',
    category: 'Lifestyle',
    status: 'Published',
    iconUrl: '/app-icons/kinora.png',
    androidUrl: 'https://play.google.com/store/apps/details?id=com.pradappandiyan.kinora',
    features: ['Reminders', 'Notes', 'Moments', 'Stay connected']
  },
  {
    id: 'indru',
    name: 'Indru — இன்று',
    tagline: 'What happened today',
    description:
      'See what happened today in India, Tamil Nadu, and the world — in English and Tamil.',
    platform: 'Android',
    category: 'News',
    status: 'Published',
    iconUrl: '/app-icons/indru.png',
    androidUrl: 'https://play.google.com/store/apps/details?id=com.pradappandiyan.whatstoday',
    features: ['Daily events', 'English & Tamil', 'India & world', 'Tamil Nadu focus']
  },
  {
    id: 'text-clipboard',
    name: 'Text Clipboard Manager',
    tagline: 'Smart clipboard for Mac',
    description:
      'Clipboard history and productivity tools for macOS. Never lose important copied text again with an intelligent, feature-rich clipboard manager.',
    platform: 'Mac',
    category: 'Productivity',
    status: 'Published',
    iconUrl:
      'https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/14/11/d8/1411d856-9e97-3a49-47b4-b294d257fd93/AppIcon-0-0-85-220-0-5-0-2x.png/512x512bb.png',
    macUrl: 'https://apps.apple.com/us/app/text-clipboard-manager/id6751362717',
    features: ['Clipboard history', 'macOS', 'Quick access', 'Productivity']
  }
];

export const developerStores = {
  appStore: 'https://apps.apple.com/us/developer/pradap-pandiyan/id1833284936',
  playStore: 'https://play.google.com/store/apps/developer?id=Pradap+Pandian&hl=en'
};
